let resetCache = false;

const metainfInitialState = {
  fetching: false,
};

const metainf = (state = metainfInitialState, action) => {
  switch (action.type) {
    case 'FETCH_METAINF':
      return {
        ...state,
        fetching: true,
      };

    case 'FETCH_METAINF_SUCCESS':
      resetCache = true;
      return {
        ...state,
        fetching: false,
        data: action.metainf,
      };

    case 'FETCH_METAINF_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    default:
      return state;
  }
};

const createCachingMetainfSelector = () => {
  let cache = {};

  return (state, event) => {
    if (!state.data) {
      return { meta: {}, groups: [] };
    }

    if (resetCache) {
      cache = {};
    }

    // в fields объединяются fields и events каждой группы (и остаются непустые)
    if (!cache[event]) {
      cache[event] = {
        meta: { ...state.data.meta.common, ...(state.data.meta.events[event] || {}) },
        groups: state.data.groups
          .map((g) => ({
            ...g,
            fields: [...(g.fields || []), ...((g.events || {})[event] || [])],
          }))
          .filter((g) => g.fields.length > 0),
      };
    }

    resetCache = false;
    return cache[event];
  };
};

export default metainf;

export const getMetainf = createCachingMetainfSelector();

export const getEventNames = (state) => state.data?.events;

export const getFieldPathsFor = (state, entry) => state.data.paths[entry] || [];

export const getFieldPathKeys = (state) => Object.keys(state.data.paths);

export const isFetching = (state) => state.fetching;
